<template>
    <div class="scc-pagination">
        <div v-show="!isInFirstPage" class="scc-pagination__previous-button" @click="onClickPreviousPage">
            <img :src="leftArrowIcon" alt="icon" />
        </div>
        <template v-for="(page, i) in pages">
            <button
                :key="i"
                class="scc-pagination__button"
                :class="{ 'scc-pagination__button--active': isPageActive(page.name) }"
                @click="onClickPage(page.name)"
            >
                {{ page.name }}
            </button>
        </template>
        <div v-show="!isInLastPage" class="scc-pagination__next-button" @click="onClickNextPage">
            <img :src="rightArrowIcon" alt="icon" />
        </div>
    </div>
</template>

<script>
import './pagination.scss';

export default {
    name: 'Pagination',
    components: {},
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 5,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pageNumber: 1,
            leftArrowIcon: require('@/assets/icons/arrow-left.svg'),
            rightArrowIcon: require('@/assets/icons/arrow-right.svg'),
        };
    },
    computed: {
        startPage() {
            // When on the first page
            if (this.currentPage === 1 || this.currentPage === 2) {
                return 1;
            }
            // When on the last page
            if (this.currentPage === this.totalPages) {
                return this.totalPages - this.maxVisibleButtons + 2;
            }

            // When single to last page
            if (this.currentPage === this.totalPages - 1) {
                if (this.totalPages >= this.maxVisibleButtons) return this.totalPages - this.maxVisibleButtons + 1;
            }
            // When in between
            return this.currentPage - 2;
        },
        pages() {
            const range = [];

            let maxButtons = this.maxVisibleButtons;

            if (this.currentPage === 1) maxButtons = maxButtons - 1;

            for (let i = this.startPage; i <= Math.min(this.startPage + maxButtons - 1, this.totalPages); i += 1) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage,
                });
            }

            return range;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
    },
    methods: {
        isPageActive(page) {
            return this.currentPage === page;
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pagechanged', page);
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1);
        },
    },
};
</script>
